/**
 * Main Media Component
 * CERA Social 탭 필터 기능
 */
export class MainMedia {
    constructor() {
        this.tabButtons = null;
        this.mediaItems = null;
        this.activeCategory = null;
    }

    init() {
        const container = document.querySelector('.no-main-media');
        if (!container) return;

        this.tabButtons = container.querySelectorAll('.no-main-media__tab-btn');
        this.mediaItems = container.querySelectorAll('.no-main-media__item');

        if (!this.tabButtons.length || !this.mediaItems.length) return;

        // 활성화된 탭 버튼에서 초기 카테고리 가져오기
        const activeBtn = container.querySelector('.no-main-media__tab-btn.--active');
        if (activeBtn) {
            this.activeCategory = activeBtn.getAttribute('data-category');
        } else {
            // 활성화된 탭이 없으면 첫 번째 탭을 활성화
            if (this.tabButtons.length > 0) {
                this.activeCategory = this.tabButtons[0].getAttribute('data-category');
                this.tabButtons[0].classList.add('--active');
            }
        }

        // 탭 버튼 이벤트 리스너
        this.tabButtons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const category = btn.getAttribute('data-category');
                this.switchTab(category);
            });
        });

        // 초기 필터 적용
        if (this.activeCategory) {
            this.filterItems(this.activeCategory);
        }
    }

    switchTab(category) {
        // 활성 탭 변경
        this.tabButtons.forEach((btn) => {
            if (btn.getAttribute('data-category') === category) {
                btn.classList.add('--active');
            } else {
                btn.classList.remove('--active');
            }
        });

        // 필터 적용
        this.activeCategory = category;
        this.filterItems(category);
    }

    filterItems(category) {
        this.mediaItems.forEach((item) => {
            const itemCategory = item.getAttribute('data-category');
            
            if (itemCategory === category) {
                item.classList.remove('--hidden');
            } else {
                item.classList.add('--hidden');
            }
        });
    }
}

